// removed by extract-text-webpack-plugin
module.exports = {"state-chip":"index__state-chip--36vrM","ellipsis-loading":"index__ellipsis-loading--1mchl","ellipsis":"index__ellipsis--3QO-K","btn-actions":"index__btn-actions--2Tw6U","fetching":"index__fetching--2eIG6","available":"index__available--SFZEr","pending":"index__pending--nNiCC","approved":"index__approved--Y4G4F","disapproved":"index__disapproved--3-eEW","deploying":"index__deploying--1NoQj","deployed":"index__deployed--1Sun2","paused":"index__paused--27Du4","invalid":"index__invalid--3mTHA","icon":"index__icon--1xqbA"};


//////////////////
// WEBPACK FOOTER
// ./src/client/shared-components/StateLozenge/styles/index.scss
// module id = D1P1
// module chunks = 23